import { BaseModel } from "model/BaseModel";
import MdfeEmitente from "./MdfeEmitente";
import MdfeCte from "./MdfeCte";

export default class Mdfe implements BaseModel {
    id: number | null;
    codigo: string | null = null;
    chMdfe: string;
    versao: string;
    cUF: number;
    tpAmb: number;
    tpEmit: number;
    tpTransp: number;
    mod: number;
    serie: string;
    nMDF: number;
    cMDF: number;
    cDV: string;
    modal: number;
    dhEmi: Date | null;
    tpEmis: number;
    procEmi: number;
    verProc: string;
    ufIni: string;
    ufFim: string;
    dhIniViagem: Date | null;
    indCanalVerde: string;
    indCarregaPosterior: string;
    emitente: MdfeEmitente | null;
    listMdfeCte: Array<MdfeCte>;

    constructor(
        id: number | null = null,
        chMdfe: string = "",
        versao: string = "",
        cUF: number = 0,
        tpAmb: number = 0,
        tpEmit: number = 0,
        tpTransp: number = 0,
        mod: number = 0,
        serie: string = "",
        nMDF: number = 0,
        cMDF: number = 0,
        cDV: string = "",
        modal: number = 0,
        dhEmi: Date | null = null,
        tpEmis: number = 0,
        procEmi: number = 0,
        verProc: string = "",
        ufIni: string = "",
        ufFim: string = "",
        dhIniViagem: Date | null = null,
        indCanalVerde: string = "",
        indCarregaPosterior: string = "",
        emitente: MdfeEmitente | null = null,
        listMdfeCte = new Array<MdfeCte>()
    ) {
        this.id = id;
        this.chMdfe = chMdfe;
        this.versao = versao;
        this.cUF = cUF;
        this.tpAmb = tpAmb;
        this.tpEmit = tpEmit;
        this.tpTransp = tpTransp;
        this.mod = mod;
        this.serie = serie;
        this.nMDF = nMDF;
        this.cMDF = cMDF;
        this.cDV = cDV;
        this.modal = modal;
        this.dhEmi = dhEmi;
        this.tpEmis = tpEmis;
        this.procEmi = procEmi;
        this.verProc = verProc;
        this.ufIni = ufIni;
        this.ufFim = ufFim;
        this.dhIniViagem = dhIniViagem;
        this.indCanalVerde = indCanalVerde;
        this.indCarregaPosterior = indCarregaPosterior;
        this.emitente = emitente;
        this.listMdfeCte = listMdfeCte;
    }
    
}